module.exports = { id: "gears", url: "/build/app/img/symbols.svg#gears", viewBox: "", toString: function() { return this.url; } };